import React from "react";
import { motion } from "framer-motion";
import { Crown, CalendarBlank, MapPin, ArrowRight } from "@phosphor-icons/react";

export const AdBanner = ({ onCta }) => {
  return (
    <motion.aside
      data-testid="masthead-ad"
      initial={{ opacity: 0, x: 24 }}
      animate={{ opacity: 1, x: 0 }}
      transition={{ duration: 0.6, delay: 0.2, ease: "easeOut" }}
      className="relative w-full max-w-[300px] overflow-hidden rounded-2xl border border-amber-400/25"
    >
      <span className="absolute right-3 top-3 z-20 rounded bg-black/50 px-2 py-0.5 text-[10px] font-medium uppercase tracking-wider text-slate-300 backdrop-blur-sm">
        Advertisement
      </span>

      <div className="absolute inset-0">
        <img
          src="/ad-franchise-india-mumbai.jpg"
          alt="Franchise India 2026 Mumbai"
          className="h-full w-full object-cover"
        />
        <div className="absolute inset-0 bg-gradient-to-t from-[#0B0D17] via-[#0B0D17]/25 to-[#0B0D17]/50" />
      </div>

      <div className="relative flex h-full flex-col justify-between p-5" style={{ minHeight: 380 }}>
        <div>
          <span className="inline-flex items-center gap-1.5 rounded-full border border-amber-400/40 bg-amber-400/15 px-2.5 py-1 text-[11px] font-semibold text-amber-300">
            <Crown size={12} weight="fill" /> Featured Event
          </span>
          <h3 className="mt-3 font-display text-2xl font-extrabold leading-tight tracking-tight text-white">
            Franchise India 2026
          </h3>
          <p className="mt-1 text-sm font-medium text-blue-300">India's Biggest Franchise &amp; Licensing Show</p>
        </div>

        <div>
          <div className="mb-4 space-y-1.5 text-sm text-slate-200">
            <p className="flex items-center gap-2">
              <CalendarBlank size={15} weight="fill" className="text-amber-300" /> Oct 10 – 11, 2026
            </p>
            <p className="flex items-center gap-2">
              <MapPin size={15} weight="fill" className="text-amber-300" /> Mumbai, India
            </p>
          </div>
          <button
            data-testid="masthead-ad-cta"
            onClick={onCta}
            className="group inline-flex w-full items-center justify-center gap-1.5 rounded-full bg-amber-400 px-5 py-3 text-sm font-bold text-black transition-colors duration-200 hover:bg-amber-300"
          >
            Get Tickets
            <ArrowRight size={16} weight="bold" className="transition-transform duration-200 group-hover:translate-x-0.5" />
          </button>
        </div>
      </div>
    </motion.aside>
  );
};
